import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';
import useUserStore from "../../utils/storeApp";

const HeaderReports = () => {
    const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
        isUserLogedIn: state.isUserLogedIn,
        userRole: state.userRole,
        userToken: state.userToken,
    }));
    return (
        <div className="HeaderReports">
            {userRole === "SES ADMINISTRATOR" || userRole === "ADMINISTRATOR" ? (
            <section>
                <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar">
                    <div className="container w-max2">
                        {/*Main Header*/}
                        <div className="admin-title">
                            <i className="bi bi-journal-medical" title="Healthcare Icon"></i> <span>REPORTS</span>
                        </div>
                        {/*Admin Menus*/}
                        <NavAdmin />
                    </div>
                </nav>
                </section>
            ) : null}
        </div>
    );
};

export default HeaderReports;
